import { render, staticRenderFns } from "./UserTitle.vue?vue&type=template&id=b3a4458a&scoped=true&"
import script from "./UserTitle.vue?vue&type=script&lang=js&"
export * from "./UserTitle.vue?vue&type=script&lang=js&"
import style0 from "./UserTitle.vue?vue&type=style&index=0&id=b3a4458a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a4458a",
  null
  
)

export default component.exports